<template>
  <div class="container-fluid">
    <div class="container">
      <div role="toolbar" class="btn-toolbar justify-content-between">
        <div class="btn-group">
          <button class="btn btn-secondary" @click="$emit('save')">Zur&uuml;ck</button>
          <button class="btn btn-secondary" @click="editJSON"><font-awesome-icon icon="edit"/>&nbsp;JSON</button>
          <button class="btn btn-secondary" @click="$emit('test')"><font-awesome-icon icon="vial"/>&nbsp;Test</button>
        </div>
      </div>
      <div class="form-group">
        <label>Name</label>
        <div class="input-group">
          <input class="form-control" v-model="table.name" type="text"/>
        </div>
        <small class="form-text text-muted">Kurzer Name für die Tabellenquelle</small>
      </div>
      <button v-b-toggle.collapse-1 class="btn btn-primary">Spalten</button>
      <b-collapse id="collapse-1" class="mt-2">
        <div class="wrapper card">
          <div class="row p-3">
            <div class="col">
              <div class="form-group">
                <button @click="loadColumns" class="btn btn-secondary" id="colfetch">Spalten holen</button>
              </div>
              <datalist id="columnslist">
                <option v-for="cn in sourceColumns" :key="cn.name" :value="mapColumnValue(cn)">{{ cn.name }}</option>
              </datalist>
              <div class="form-inline">
                <label class="ml-2">Spalten</label>
                <select class="form-control ml-2" v-model="colindex">
                  <option v-for="(cn,index) in sourceColumns" :key="index" :value="index">{{ cn.name }}</option>
                </select>
                <button @click="insertColumn" class="btn btn-primary ml-2">Einfügen</button>
                <button @click="insertAllColumns" class="btn btn-secondary ml-2">Alle einfügen</button>
              </div>
            </div>
            <div class="col">
              <div class="input-group">
                <span class="input-group-text">Vorlage</span>
                <select class="form-control" v-model="dataTemplate">
                  <option v-for="t in colTemplates" :key="t.class" :value="t">{{ t }}</option>
                </select>
                <div class="input-group-append">
                  <button @click="insertTemplate" class="btn btn-secondary">Einfügen</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
    <div class="container" v-if="isjoin" name="join">
      <div class="card mx-3 my-3 col-sm">
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>TableKey</label>
              <select class="form-control" v-model="table.joinTableKey">
                <option v-for="(p,idx) in isjoin.properties" :key="idx" :value="p.name" >{{ p.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-sm">
            <div class="form-group">
              <label>ForeignKey</label>
              <div class="input-group">
                <select v-if="!table.tableref || table.tableref == ''" class="form-control" v-model="table.joinForeignKey">
                  <option v-for="(p,idx) in table.properties" :key="idx">{{ p.name }}</option>
                </select>
                <select v-else class="form-control" v-model="table.joinForeignKey">
                  <option v-for="(p,idx) in templatefields" :key="idx">{{ p.name }}</option>
                </select>
                <div class="input-group-append">
                  <button id="jreload" class="btn btn-secondary">Laden</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>Join Type</label>
              <select class="form-control" v-model="table.joinType">
                <option value="0">Mehrzeilig</option>
                <option value="1">Nur erstes Element</option>
                <option value="2">Listenattribute</option>
                <option value="3">Map-Attribute</option>
              </select>
            </div>
          </div>
          <div class="col-sm">
            <div v-show="table.joinType > 1" class="form-group">
              <label>Attribute</label>
              <input type="text" class="form-control" v-model="table.joinAttr"/>
            </div>
            <div v-show="table.joinType > 2" class="form-group">
              <label>Map-Key-Attribute</label>
              <input type="text" class="form-control" v-model="table.joinMapAttr"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group">
            <div class="col-xl">
              <label>Tabellenvorlage:</label>
              <select @change="selectTemplateTable" class="form-control" v-model="table.tableref">
                <option value="">keine Auswahl</option>
                <option v-for="tentry in tablelist" :key="tentry.name" :value="tentry.name">{{ tentry.name }}</option>
              </select>
              <small>Nehmen Sie eine Tabellenvorlage oder konfigurieren Sie unten eine individuellen Join.</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div name="main" class="container">
      <div class="card mx-3 my-3 col-sm" name="tableeditor">
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>Datentyp:</label>
              <select class="form-control" v-model="table.type" name="dsformat">
                <option value="">-</option>
                <option value="csv">CSV</option>
                <option value="xml">XML</option>
                <option value="json">JSON</option>
                <option value="sql">SQL</option>
                <option value="dbf">DBF</option>
                <option value="xlsx">XLS</option>
              </select>
              <small class="form-text text-muted">Datenformat der Datenquelle</small>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md">
            <div name="json-config" v-if="table.type == 'json'">
              <div class="form-group">
                <label>Wurzelpfad</label>
                <input class="form-control" v-model="table.root" type="text"/>
              </div>
            </div>
            <div name="sql-config" v-if="table.type == 'sql'">
              <div class="form-group">
                <label>SQL-Abfrage</label>
                <textarea class="form-control" v-model="table.sqlquery"></textarea>
              </div>
            </div>
            <div name="xml-config" v-if="table.type=='xml'">
              <div class="form-group">
                <label>Eintrag XPath</label>
                <input class="form-control" v-model="table.entryPath" type="text"/>
              </div>
              <div class="form-group">
                <label>Encoding</label>
                <input class="form-control" v-model="table.encoding" type="text" size="6"/>
              </div>
              <div class="form-group">
                <label>BOM Skip</label>
                <input class="form-control" v-model="table.bomskip" type="text" size="6"/>
              </div>
              <div class="form-check">
                <input id="allDataxml" class="form-check-input" type="checkbox" true-value="1" false-value="0" v-model="table.useAllData"/>
                <label for="allDataxml">Alle Daten benutzer (ausserhalb des Haupt-XPath)</label>
              </div>
            </div>
            <div name="csv-config" v-if="table.type == 'csv'">
              <div class="form-group">
                <label>Titelzeile</label>
                <input class="form-control" true-value="0" false-value="1" v-model="table.usecols" type="checkbox"/>
              </div>
              <div class="form-group">
                <label>Feste Länge</label>
                <input class="form-control" v-model="table.fixedWidth" type="checkbox"/>
              </div>
              <div class="form-group">
                <label>Encoding</label>
                <input class="form-control" v-model="table.encoding" type="text" size="6"/>
              </div>
              <div class="form-group">
                <label>Separator</label>
                <input class="form-control" v-model="table.separator" type="text" size="6"/>
                <small class="form-text text-muted">Sonderzeichen mit "char:[CharCode]" eingeben, z.B. Tabulator: "char:9".</small>
              </div>
              <div class="form-group">
                <label>Text Trenner</label>
                <input class="form-control" v-model="table.strchar" type="text" size="6"/>
              </div>
              <div class="form-group">
                <label>Text Trenner Escape</label>
                <input class="form-control" v-model="table.stresc" type="text" size="6"/>
              </div>
              <div class="form-group">
                <label>Spaltenzahl</label>
                <input class="form-control" v-model="table.mincols" type="text" size="6"/>
              </div>
              <div class="form-group">
                <label>Mehrzeilig</label>
                <input class="form-control" v-model="table.multiline" type="checkbox"/>
              </div>
            </div>
            <div name="xlsx-config" v-if="table.type == 'xlsx'">
              <div class="form-group">
                <label>Tabellenindex</label>
                <input class="form-control" v-model="table.sheet" type="text" size="4"/>
              </div>
              <div class="form-group">
                <label>Startzeile</label>
                <input class="form-control" v-model="table.row" type="text" size="4"/>
              </div>
            </div>
          </div>
          <div class="col-md">
            <strong>Datenfelder</strong><br/>
            <div name="fieldlist" class="container" style="overflow:auto;max-height:800px;">
              <div v-for="(p,idx) in table.properties" class="row bchild" :key="idx">
                <DataTableField :table="table" :prop="p" @edit="editField" @moveup="moveFieldUp(idx)" @movedown="moveFieldDown(idx)" @delete="deleteField(idx)"/>
              </div>
            </div>
            <div class="m-3" style="text-align:right;">
              <button class="btn btn-info" @click="addField" name="newfield">Neues Feld</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="fieldEditor" title="Feldkonfiguration" size="lg" ok-only>
      <div class="form-group">
        <label>Name</label>
        <input class="form-control" v-model="efield.name" id="focstart" autofocus type="text"/>
      </div>
      <div class="form-group">
        <label>Datentyp</label>
        <select class="form-control" v-model="efield.type">
          <option value="string">String</option>
          <option value="integer">Integer</option>
          <option value="long">Long</option>
          <option value="double">Double</option>
          <option value="timestamp">Zeitstempel</option>
          <option value="boolean">Boolean</option>
          <option value="jsonobj">JSON Object</option>
          <option value="jsonarray">JSON Array</option>
          <option value="automap">AutoMap</option>
        </select>
      </div>
      <div class="form-group">
        <label>Standardwert</label>
        <input class="form-control" v-model="efield.default" type="text"/>
      </div>
      <div class="form-inline">
        <label>ID Feld</label>
        <input class="form-control ml-2" v-model="efield.idcolumn" type="checkbox"/>
      </div>
      <div class="form-inline">
        <label>Extrafeld</label>
        <input class="form-control ml-2" v-model="efield.extra" type="checkbox"/>
      </div>
      <br/>
      <div name="extend-field">
      </div>
      <div class="card card-body" style="margin-bottom:10px;">
        <button class="btn btn-primary" v-b-toggle.fieldextended type="button">
          Erweitert
        </button>
        <b-collapse id="fieldextended" class="mt-2">
          <div class="form-group">
            <label>RegEx</label>
            <input class="form-control" v-model="efield.regex" type="text"/>
          </div>
          <div class="form-group">
            <label>Replace (optional)</label>
            <input class="form-control" v-model="efield.replace" type="text"/>
          </div>
          <div name="dsformat" class="form-group">
            <label>Datumsformat</label>
            <input class="form-control" v-model="efield.dsformat" type="text"/>
          </div>
          <div class="form-group">
            <label>Skriptregel</label>
            <textarea class="form-control" v-model="efield.script"></textarea>
          </div>
        </b-collapse>
      </div>
    </b-modal>
    <b-modal id="jsonTableEdit" size="lg" title="JSON Editor" @ok="updateJSONTable">
      <textarea rows="25" cols="60" v-model="jsontable"/>
    </b-modal>
  </div>
</template>

<script>
import config from '@/modules/config.js'
//import AceEditor from '@/components/AceEditor.vue'

// TODO replace by interface for generel use of generic data ui
import datamap from '@/modules/datamap.js'
import DataTableField from '@/components/genericdata/DataTableField.vue'

export default {
  name: 'DataTableEditor',
  props: ["table","source","isjoin","colTemplates"],
  components: {
    DataTableField,
  },
  data() {
    return {
      dataTemplate: false,
      sourceColumns: [],
      efield: {},
      jsontable: "",
      tablelist: [],
      templatefields: {},
      colindex: -1,
      typeMap: {
        "java.lang.String":"string",
        "java.lang.Long":"long",
        "java.lang.Integer":"integer",
        "java.util.Date":"timestampt",
        "java.lang.Double":"double",
        "java.lang.Boolean":"boolean",
      },
    }
  },
  mounted: function() {
    var self = this;
    datamap.listtables(this,0,500,'name','',function(data) {
      self.tablelist = data;
    })
  },
  methods: {
    insertTemplate() {
      console.log(this.dataTemplate);
      var self = this;
      fetch(config.baseUrl + 'rest/datamap/jsonmeta/' + encodeURIComponent(this.dataTemplate)).then(resp => resp.json()).then(function(data) {
        console.log(data);
        var cols = [];
        while (data) {
          console.log('add cols: ' + data);
          if (data.attr && data.attr.length > 0) {
            for (var i=0;i<data.attr.length;i++) {
              var type = self.typeMap[data.attr[i].type] || 'string';
              self.table.properties = self.table.properties || [];
              self.table.properties.push({"name":data.attr[i].jname, "type":type});
            }
          }
          data = data.super;
        }
        self.$forceUpdate();
        console.log(cols);
      })
    },
    mapColumnValue(cn) {
      console.log(cn);
      if (this.table.type == 'xml' && cn.xpath) {
        return cn.xpath;
      }
      return cn.name;
    },
    loadColumns: function() {
      if (!this.table.properties || this.table.properties.length == 0) {
        this.$bvToast.toast('Bitte legen Sie zuerst ein Platzhalter Feld an.',{title: 'Spaltennamen holen',variant:'warning'});
        return;
      }
      config.post(this,config.baseUrl + 'rest/datamap/columncheck','Spaltennamen laden',JSON.stringify({table: this.table, datasource: this.source }),this.receiveColumns.bind(this));
    },

    receiveColumns: function(cols) {
      this.sourceColumns = cols;
      this.$bvToast.toast('Spalten eingelesen.',{title: 'Spalten laden',variant:'success'});
    },

    insertColumn() {
      console.log(this.sourceColumns[this.colindex]);
      var entry = JSON.parse(JSON.stringify(this.sourceColumns[this.colindex]));
      entry.type = "string";
      this.table.properties.push(entry);
      this.$forceUpdate();
    },

    insertAllColumns() {
      for (var i=0;i<this.sourceColumns.length;i++) {
        var entry = JSON.parse(JSON.stringify(this.sourceColumns[i]));
        console.log(entry);
        entry.type = "string";
        this.table.properties.push(entry);
      }
      this.$forceUpdate();
    },

    selectTemplateTable: function() {
      // select table from list
      for (var i in this.tablelist) {
        if (this.tablelist[i].name == this.table.tableref) {
          // reset field selection
          this.templatefields = {};

          console.log('got selected table:');

          // check config and tables
          var config = this.tablelist[i].config;

          if (config && config.tables) {
            // iterate given sub tables
            for (var c in this.tablelist[i].config.tables) {
              var subtable = this.tablelist[i].config.tables[c];
              console.log('got properties? ');
              console.log(subtable);
              if (subtable.table && subtable.table.properties) {
                // iterate property fields
                for (var p in subtable.table.properties) {
                  var pf = subtable.table.properties[p];
                  this.templatefields[pf.name] = pf;
                }
              }
            }
          }

          console.log(this.templatefields);
          this.$forceUpdate();
        }
      }
    },
    moveFieldUp: function(idx) {
      console.log('up: ' + idx);
      if (idx <= 0) return;
      var m1 = this.table.properties[idx-1];
      this.table.properties[idx-1] = this.table.properties[idx];
      this.table.properties[idx] = m1;
      this.$forceUpdate();
    },
    moveFieldDown: function(idx) {
      console.log('down: ' + idx);
      console.log('up: ' + idx);
      if (idx >= this.table.properties.length - 1) return;
      var m1 = this.table.properties[idx+1];
      this.table.properties[idx+1] = this.table.properties[idx];
      this.table.properties[idx] = m1;
      this.$forceUpdate();
    },
    deleteField: function(idx) {
      console.log('del: ' + idx);
      this.table.properties.splice(idx,1);
    },
    addField: function() {
      if (!this.table.properties) this.table.properties = [];
      this.table.properties.push({"name":"field" + this.table.properties.length,"type":"string"});
      this.$forceUpdate();
    },
    editField: function(field) {
      this.efield = field;
      this.$bvModal.show('fieldEditor')
    },
    editJSON: function() {
      this.jsontable = JSON.stringify(this.table,null,'\t');
      this.$bvModal.show('jsonTableEdit');
    },
    updateJSONTable: function(e) {
      try {
        var test = JSON.parse(this.jsontable);
      } catch (err) {
        this.$bvToast.toast('Konnte JSON nicht parsen.\n' + err,{title:'Fehler',variant:"danger"});
        e.preventDefault();
        return;
      }
      for (var k in test) {
        this.table[k] = test[k];
      }
      //this.table = test;
      this.$emit('jsonupdate',this.table);
    }
  },
}
</script>
